import React from 'react';
import useTranslation from '@src/hooks/useTranslation';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import {
	PREPARATION_MATERIAL, PREPARATION_BACKGROUND, PREPARATION_OUTCOME, PREPARATION_TARGET_AUDIENCE,
} from '@src/const/course';

import { BulletIcon } from 'src/components/common/icon';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';
import BulletListItem from '@src/components/common/bulletListItem';
import { GridContent } from '@src/components/common/bulletListItem/styled';

const PREPARATION_LIST = [
	PREPARATION_MATERIAL, PREPARATION_BACKGROUND, PREPARATION_OUTCOME, PREPARATION_TARGET_AUDIENCE,
];

const PreparationBeforeCourse = (): JSX.Element => {
	const { t } = useTranslation();
	const { currentCourse } = useCurrentCourse();
	const preparationOptionExistData = PREPARATION_LIST.filter(preparationOption => !!currentCourse[preparationOption]);
	if (preparationOptionExistData.length === 0) return <div id="preparation_before_course" />;
	return (
		<BlockWrapper id="preparation_before_course">
			<Header text={t('course:information:preparation_before_course')} />
			<GridContent>
				{PREPARATION_LIST.map(preparationOption => currentCourse[preparationOption] && (
					<BulletListItem
						key={preparationOption}
						title={t(`course:preparation_before_course:${preparationOption}`)}
						content={currentCourse[preparationOption]}
						BulletIcon={BulletIcon}
					/>
				))}
			</GridContent>
		</BlockWrapper>
	);
};

export default PreparationBeforeCourse;
